export const MOBILE_BREAKPOINT = 768;
export const SPLASH_DURATION = 3000;